export default "Mairies et hôtels de ville : rénovation énergétique, décret tertiaire et primes CEE. Diagnostic, plan d'actions 2030 et financement (Fonds vert, DETR/DSIL).";
